module.exports = __webpack_public_path__ + "static/media/warn-circle.d6bbf484.svg";